import { SVG_CALENDAR_OUTLINED } from '@getgo/chameleon-icons';
import { html, ref } from '@microsoft/fast-element';
import { DatePickerComponent } from './DatePicker';
import styles from './DatePicker.styles.scss';
const datePickerPopoverTemplate = html `<template>
  <chameleon-text-field
    value="${(x) => x.value}"
    placeholder="${(x) => x.placeholder}"
    error="${(x) => x.error}"
    disabled="${(x) => x.disabled}"
    ${ref('field')}
    @keydown="${(el, { event }) => el.handleTextFieldKeydown(event)}"
  >
    ${(x) => x.inputLabel}
    <span slot="helpertext">${(x) => x.helperText}</span>
    <chameleon-icon-button id="trigger" slot="end" disabled="${(x) => x.disabled}">
      <chameleon-svg>${SVG_CALENDAR_OUTLINED}</chameleon-svg>
    </chameleon-icon-button>
  </chameleon-text-field>
  <chameleon-popover-v2
    trigger-id="trigger"
    slot="end"
    :position="${(x) => x.position}"
    ${ref('popoverElement')}
    @popoverchange="${(el, { event }) => el.handlePopoverChanged(event)}"
    :anchorElement=${(el) => el.field}
    style="--additional-offset-y: ${(el) => el.popoverOffset}"
  >
    <div
      role="rowgroup"
      aria-label="${(x) => { var _a; return (_a = x.calendar) === null || _a === void 0 ? void 0 : _a.dateFormatter.getMonth(); }}, ${(x) => { var _a; return (_a = x.calendar) === null || _a === void 0 ? void 0 : _a.dateFormatter.getYear(); }}"
    >
      <slot name="header"></slot>
      <chameleon-calendar
        ${ref('calendar')}
        locale="${(x) => x.locale}"
        popover-mode
        @change="${(el, { event }) => el.handleCalendarChanged(event)}"
        selected-dates="${(x) => x.value}"
      ></chameleon-calendar>
    </div>
  </chameleon-popover-v2>
</template>`;
const datePickerStandaloneTemplate = html `<template
  ><div
    part="wrapper"
    role="rowgroup"
    aria-label="${(x) => { var _a; return (_a = x.calendar) === null || _a === void 0 ? void 0 : _a.dateFormatter.getMonth(); }}, ${(x) => { var _a; return (_a = x.calendar) === null || _a === void 0 ? void 0 : _a.dateFormatter.getYear(); }}"
  >
    <slot name="header"></slot>
    <chameleon-calendar
      ${ref('calendar')}
      locale="${(x) => x.locale}"
      selected-dates="${(x) => x.value}"
      @change="${(el, { event }) => el.handleCalendarChanged(event)}"
    ></chameleon-calendar>
  </div>
</template>`;
export const chameleonDatePicker = DatePickerComponent.compose({
    baseName: 'date-picker',
    template: html `${(x) => (x.popoverMode ? datePickerPopoverTemplate : datePickerStandaloneTemplate)}`,
    styles,
});
